import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'helpers';


export const utilsApi = createApi({
  reducerPath: 'utilsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.server,
    credentials: 'include',
  }),
  endpoints: (build) => ({
    config: build.query({
      query: () => ({
        url: `config`,
        method: 'GET',
      }),
    }),
    configuration: build.query({
      query: () => ({
        url: `configuration`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyConfigQuery,
  useLazyConfigurationQuery,
} = utilsApi;
